import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-phonefield', 'INVALID', 'Sisestud telefoninumber on vigane.');
Labels.set('ui-phonefield', 'CHOOSE_COUNTRY', 'Valige riik.');
Labels.set('ui-phonefield', 'PHONENR', 'Telefoninumber');
